// import type { TransactionsFilters } from "@stepfinance/transaction-history";
import create from "zustand";

// export type TransactionsFiltersState = Omit<TransactionsFilters, "page" | "itemsPerPage">;

export type TransactionsFilters = {
  page?: number;
  itemsPerPage?: number;
  sortDesc?: boolean;
  startDate?: string;
  platforms?: string[];
  endDate?: string;
  mints?: string[];
  txId?: string;
};

export type TransactionHistoryStore = {
  tiersModalOpen: boolean;
  selectedYear: number;
  yearsAvailable: number[];
  isAuthorized: boolean;
  filters: TransactionsFilters;
  updateFilters: (filters: TransactionsFilters) => void;
  setYearsAvailable: (value: number[]) => void;
  setTiersModalOpen: (value: boolean) => void;
  setSelectedYear: (selectedYear: number) => void;
  setIsAuthorized: (isAuthorized: boolean) => void;
};

const currentYear = new Date().getFullYear();

export const defaultStartDate = () => new Date(currentYear, 0, 1);

export const defaultEndDate = () => new Date();

export const useTransactionHistoryStore = create<TransactionHistoryStore>((set, get) => ({
  tiersModalOpen: false,
  selectedYear: currentYear,
  yearsAvailable: [new Date().getFullYear()],
  isAuthorized: false,
  filters: {
    itemsPerPage: 35,
    startDate: defaultStartDate().toISOString(),
    endDate: defaultEndDate().toISOString(),
  },
  updateFilters: (filters: TransactionsFilters) => {
    const currentFilters = get().filters;
    const newFilters = { ...currentFilters, ...filters };
    set({ filters: newFilters });
  },
  setYearsAvailable: (value: number[]) => set({ yearsAvailable: value }),
  setTiersModalOpen: (value: boolean) => set({ tiersModalOpen: value }),
  setSelectedYear: (selectedYear: number) => {
    const startDate = new Date(selectedYear, 0, 1).toISOString();
    const endDate =
      selectedYear === currentYear ? new Date().toISOString() : new Date(selectedYear, 11, 31).toISOString();
    const currentFilters = get().filters;
    set({ selectedYear, filters: { ...currentFilters, startDate, endDate } });
  },
  setIsAuthorized: (isAuthorized: boolean) => set({ isAuthorized }),
}));
